<script>
import Criteria from "./criteria.svelte"
import FactorList from "./factorlist.svelte"
</script>

<div>
<Criteria />
<FactorList />
</div>